import React from 'react';
import { Asterisk as AsteriskIcon } from '@wix/wix-ui-icons-common/system';

import { dataHooks } from '../../constants';
import { LegendSize } from '../../FieldSet.types';

import { st, classes } from './Asterisk.st.css';
import { useIcons } from '../../../WixDesignSystemIconThemeProvider';

const Asterisk = ({ labelSize }: { labelSize: LegendSize }) => {
  const icons = useIcons('FieldSetAsterisk', {
    Asterisk: AsteriskIcon,
  });

  return (
    <div
      aria-hidden
      data-hook={dataHooks.asterisk}
      className={st(classes.root, {
        labelSize,
      })}
    >
      <icons.Asterisk />
    </div>
  );
};

export { Asterisk };
